export const SOLUTION_TO_CANONICAL_URL_MAPPING = {
  "113127": "https://monday.com/templates/content-planning"
};

export const getSolutionThumbnail = (solutionData) => {
  return solutionData?.thumbnailUrl || (solutionData?.images && solutionData?.images[0]?.url);
};

export const getSolutionName = (solutionData) => {
  return solutionData?.name;
};

export const getSolutionDescription = (solutionData) => {
  return solutionData?.description;
};

export const getSolutionShortDescription = (solutionData) => {
  return solutionData?.shortDescription || solutionData?.description;
};

export const getSolutionEnglishName = (solution) => {
  //Takes the not translated solution name not from the solution data
  return solution?.name || getSolutionName(solution?.data);
};

export const getSolutionId = (solution) => {
  // using app_feature_reference_id since it doesn't change and id can change with new versions
  return solution?.app_feature_reference_id || solution?.id;
};

export const getSolutionCategoryIds = (solutionData) => {
  return solutionData?.categories || [];
};
